export enum QnaActionLogs {
  IMPRESSION_QNA_DIAGNOSIS_REVIEWS = 'impression_qna_diagnosis_reviews',
}
